import { style } from 'styled-system';
import { colors } from '../colors';

const ALPHA_BASE = 0.07;
const ALPHA_FACTOR = 0.005;
const BLUR_BASE = 1;
const BLUR_FACTOR = 2;
const SPREAD_BASE = 1;

export type Elevation = number | number[];

export const convertHex = (hex: string, opacity = 1) => {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const applyElevation = style({
  prop: 'elevation',
  cssProperty: 'box-shadow',
  transformValue: (elevation) => {
    const blur = Number(elevation) * BLUR_FACTOR + BLUR_BASE;
    const spread = Number(elevation) + SPREAD_BASE;
    const alpha = ALPHA_BASE - Number(elevation) * ALPHA_FACTOR;
    return `0 0 ${blur}px ${spread}px ${convertHex(colors.kilamanjaro, alpha)}`;
  },
});
